/**
 * Zentrale Regeln für Schleifchen/MatchMixer: Wann ist der Playoff-Modus (rrMode TWO_SETS_MTB) zulässig.
 * Nicht mit Clubmeisterschaft-Playoffs verwechseln.
 */

/** Mehr als 7 Spieler → mindestens 8 */
export const SCHLEIFCHEN_PLAYOFF_MIN_PLAYERS = 8;

/**
 * @param {unknown} playerCount
 * @returns {boolean}
 */
export function isSchleifchenPlayoffPlayerCountEligible(playerCount) {
  const n = Number(playerCount);
  return Number.isFinite(n) && n > 7;
}

/**
 * Rotierendes Doppel (Format `doubles`) — Playoffs erfordern feste Teams.
 * @param {unknown} format - meta.settings.format
 * @returns {boolean}
 */
export function isSchleifchenRotatingDoublesFormat(format) {
  return String(format || "").toLowerCase() === "doubles";
}

/**
 * Playoffs ohne Nachfrage wählbar (genug Spieler und kein rotierendes Doppel).
 * @param {{ playerCount: unknown, format: unknown }} args
 */
export function canSelectSchleifchenPlayoffsDirectly({ playerCount, format }) {
  return isSchleifchenPlayoffPlayerCountEligible(playerCount) && !isSchleifchenRotatingDoublesFormat(format);
}

/**
 * rrMode Playoffs muss zurück auf Klassiker, wenn Spielerzahl oder Format es verbieten.
 * @param {{ playerCount: unknown, format: unknown }} args
 * @returns {boolean}
 */
export function shouldClearSchleifchenPlayoffsMode({ playerCount, format }) {
  if (!isSchleifchenPlayoffPlayerCountEligible(playerCount)) return true;
  if (isSchleifchenRotatingDoublesFormat(format)) return true;
  return false;
}
